// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Daily,
} from './';

export default {
  path: 'daily',
  name: 'Daily',
  childRoutes: [
    { path: 'daily', name: 'Daily', component: Daily, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/daily/route.js